<template>
    <AdminNavbar />
  <div class="manage-services-container">
    
    <div class="header-controls">
      <h3 class="page-title">Current Service Offerings ({{ services.length }})</h3>
        <div style="display: flex; gap: 10px;">
            <button 
                class="add-new-btn primary-btn" 
                @click="startCreateService"
            >
                ➕ Add New Service
            </button>
            <button 
                class="delete-all-btn danger-btn" 
                @click="deleteAllServices"
            >
                Delete All Services
            </button>
        </div>
    </div>
    
    <div class="action-form-area card-style form-section-style">
      <div v-if="currentAction === 'list'" class="form-placeholder">
        <p>Use the **➕ Add New Service** button to define a new offering or **Edit/Delete** an existing one.</p>
      </div>

      <CreateService 
        v-else-if="currentAction === 'create'" 
        @create-service="handleServiceCreate"
        @cancel="cancelAction"
      />

      <EditService 
        v-else-if="currentAction === 'edit'" 
        :service="selectedService"
        @update-service="handleServiceUpdate"
        @cancel="cancelAction"
      />
    </div>

    <div class="service-list-section">
        <h3 class="list-section-title">All Services</h3>
        
        <div class="service-list">
            <div 
                class="service-card card-style" 
                v-for="(service, index) in services" 
                :key="service.id || index"
            >
                <div class="service-info">
                <h4 class="service-name-title">{{ service.name }} <span class="service-id-tag">(ID: {{ service.id }})</span></h4>
                <p class="price">${{ service.price }}</p>
                <p class="description">{{ service.description.substring(0, 80) }}...</p>
                </div>

                <div class="service-actions">
                <button class="edit-btn action-btn" @click="startEditService(service)">Edit</button>
                <button class="delete-btn action-btn" @click="deleteService(service.id)">Delete</button>
                </div>
            </div>
            
            <p v-if="services.length === 0" class="no-services-msg">No services are currently listed.</p>
        </div>
    </div>
    
  </div>
</template>

<script>
import axios from 'axios'
import AdminNavbar from '@/components/admin/AdminNavbar.vue'
import CreateService from '@/components/admin/CreateService.vue'
import EditService from '@/components/admin/EditService.vue'
import axiosInstance from '@/services/AxiosClient';

// MOCK UTILITY to simulate saving back to JSON (in-memory update)

const saveServicesToLocalStorage = (data) => {
    localStorage.setItem('salonServices', JSON.stringify(data));
    console.log("Services data successfully saved to localStorage.");
};

// Base URL for the Flask backend
const API_BASE_URL = `${process.env.VUE_APP_API_URL}/service/`;
const PIC_URL = 'https://api.kcafrobraids.com/uploads/services'
const AUTH_STORAGE_KEY = 'salon_auth'

export default {
    
    name: 'ManageServices',
    components: {
        AdminNavbar,
        CreateService,
        EditService
    },
    data() {
        return {
            adminData: {},
            services: [], 
            currentAction: 'list', 
            selectedService: null, 
            error: null
        };
    },
    async created(){
        this.services = await this.loadServices()
        this.loadAdminData()
    },
    methods: {
        loadAdminData() {
            const userData = localStorage.getItem(AUTH_STORAGE_KEY);
            console.log("Loading Admin data....")
            if (userData) {
                try {
                    this.adminData = JSON.parse(userData);
                } catch (e) {
                    console.error("Error parsing admin data from storage: ", e)
                }
            } else {
                console.log("No user data found")
            }
        },

        startCreateService() {
            this.selectedService = null;
            this.currentAction = 'create';
            window.scrollTo(0, 0); 
        },
        startEditService(service) {
            this.selectedService = { ...service }; 
            this.currentAction = 'edit';
            window.scrollTo(0, 0);
        },
        cancelAction() {
            this.selectedService = null;
            this.currentAction = 'list';
        },
        getImageUrl(filename) {
            // const API_BASE = new URL(process.env.VUE_APP_API_URL).origin;
            return `${PIC_URL}/${filename}`
        },
        async loadServices() { // load services from the backend
            try {
                const response = await axios.get(`${API_BASE_URL}get_services`)
                return response.data
            } catch (error) {
                console.error("Error fetching data:", error);
                // Handle network errors or non-200 status codes
                this.error = 'Failed to load products. Please try again later.';
                return []
            }
        },
        
        async deleteService(service_id) {
            console.log(this.adminData)
            
            const user_id = this.adminData.id
            const initialLength = this.services.length;
            if (!confirm(`Are you sure you want to delete service ID ${service_id}?`)) {
                return;
            }
            try {
                const response = await axiosInstance.delete(`${API_BASE_URL}delete/${user_id}/${service_id}`)
                console.log('Delete successful: ', response.data.message)
                this.services = this.services.filter(s => s.id !== service_id);
                if (this.services.length < initialLength) {
                saveServicesToLocalStorage(this.services); 
                alert(`Service ID ${service_id} deleted successfully.`);
            }
            } catch (error) {
                console.error("Error deleting user:", error.response ? error.response.data : error.message)
                alert("This service has an appointment!!!")
     
            }
            this.cancelAction();
        },

        async deleteAllServices() {
            console.log(this.adminData)
            
            const user_id = this.adminData.id
            if (!confirm(`Are you sure you want to delete All Services?`)) {
                return;
            }
            try {
                const response = await axiosInstance.delete(`${API_BASE_URL}delete-all-services/${user_id}`)
                this.services = [];
                console.log('Delete successful: ', response.data.message)
            } catch (error) {
                console.error("Error deleting user:", error.response ? error.response.data : error.message);
            }
            this.cancelAction();
        },

        async handleServiceUpdate(updatedService) {
            const formData = new FormData()
            const index = this.services.findIndex(s => s.id === updatedService.id);
            if (index !== -1) {
                console.log("Inside the if condition")
                const token = this.adminData.access_token;
                // Ensure to save the correct name property for the alert message
                const nameProperty = updatedService.name || 'Service';
                const imageFile = updatedService.imageFile

                // append data from child
                formData.append('name', nameProperty)
                formData.append('description', updatedService.description)
                formData.append('price', parseFloat(updatedService.price))
                formData.append('duration', updatedService.duration)

                if (updatedService.imageFile instanceof File) {
                    formData.append('image', updatedService.imageFile);
                }
                try {
                const response = await axiosInstance.post(`/service/update/${this.adminData.id}/${updatedService.id}`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
                })
                alert(`${nameProperty} updated.`);

                this.services.splice(index, 1, response.data);
                saveServicesToLocalStorage(this.services);
                
                }
                 catch (error) {
                    console.error("Update failed:", error.response?.data || error.message);
            // This is where you were seeing "Error in the program"
            alert("Failed to update service: " + (error.response?.data?.error || "Server error"));
                }
                
            }
            this.cancelAction();
        },
        async handleServiceCreate(newService) {
            this.error = null;
            this.backendMessage = null;

            // 1. Prepare FormData correctly mapped to backend expectations
            const formData = new FormData();
            
            // Explicitly mapping keys
            formData.append('name', newService.service_name);
            formData.append('description', newService.description);
            formData.append('price', newService.price);
            formData.append('duration', newService.duration_minutes);
            
            // Append the file 
            if (newService.imageFile) {
                formData.append('image', newService.imageFile);
            }

            try {
                const token = this.adminData.access_token;
                const adminId = this.adminData.id;

                const response = await axiosInstance.post(`/service/create-service/${adminId}`, formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                        // Note: Don't set Content-Type manually for FormData
                    }
                });
                
                // Update local UI
                this.services.push(response.data);
                this.backendMessage = "Service created successfully!";
                alert(`Service "${newService.service_name}" created!`);
                this.cancelAction();

            } catch (error) {
                if (error.response && error.response.data) {
                    // This will now show the EXACT SQL error we sent from the backend
                    console.error("DATABASE ERROR:", error.response.data.details);
                    this.error = `Server Error: ${error.response.data.details}`;
                } else {
                    console.error("NETWORK/UNKNOWN ERROR:", error.message);
                    this.error = error.message;
                }
                alert(this.error);
            }
        },
    }
}
</script>

<style scoped>


.manage-services-container {
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
    font-family: var(--font-sans);
    background-color: var(--color-light);
}

/* 1. HEADER CONTROLS */
.header-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    padding-bottom: 10px;

}

.page-title {
    font-family: var(--font-serif);
    font-size: 2rem;
    color: var(--color-maroon);
    border-bottom: 3px solid var(--color-gold);
    padding-bottom: 5px;
    margin: 0;
}

.primary-btn {
    padding: 12px 20px;
    background-color: var(--color-maroon);
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 700;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.primary-btn:hover {
    background-color: #4a0c19;
    transform: translateY(-1px);
}

/* 2. FORM ACTION AREA  */
.form-section-style {
    margin-top: 0; /* Align with the top content */
    margin-bottom: 40px; 
    border: 1px solid rgba(251, 191, 36, 0.3); /* Subtle gold border */
}

.action-form-area {
    min-height: 200px;
    padding: 30px;
    border-radius: 12px;
    background-color: white; 
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.form-placeholder {
    text-align: center;
    padding: 30px;
    color: var(--color-earth);
    font-size: 1.1rem;
    font-style: italic;
    border: 2px dashed var(--color-gold);
    border-radius: 8px;
    background-color: #fffaf0;
}

/* 3. SERVICE LIST SECTION */
.service-list-section {
    margin-top: 40px; /* Separator from form area */
}

.list-section-title {
    font-family: var(--font-serif);
    font-size: 1.6rem;
    color: var(--color-dark);
    margin-bottom: 15px;
    padding-left: 5px;
}

.service-list {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
}

.service-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border-left: 5px solid var(--color-gold); /* Accent line */
    transition: box-shadow 0.3s;
}

.service-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.service-info {
    flex-grow: 1;
    padding-right: 15px;
}

.service-name-title {
    font-family: var(--font-serif);
    color: var(--color-maroon);
    margin-bottom: 5px;
    font-size: 1.25rem;
    font-weight: 700;
}

.service-id-tag {
    font-size: 0.8em;
    font-weight: 400;
    color: #999;
}

.service-info .price {
    font-weight: 700;
    color: var(--success-color); 
    font-size: 1.1rem;
    margin-bottom: 8px;
}

.service-info .description {
    font-size: 0.9em;
    color: #666;
}

.service-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;
}

.action-btn {
    padding: 8px 15px;
    border: none;
    border-radius: 20px; /* Pill shape */
    cursor: pointer;
    font-weight: 600;
    font-size: 0.9rem;
    transition: opacity 0.3s;
}

.edit-btn {
    background-color: #A0522D; 
    color: white;
}

.edit-btn:hover {
    opacity: 0.9;
}

.delete-btn {
    background-color: #dc3545; 
    color: white;
}

.delete-btn:hover {
    opacity: 0.9;
}

/** Delete all services styles */
.danger-btn {
    padding: 12px 20px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 700;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.danger-btn:hover {
    background-color: #a71d2a;
    transform: translateY(-1px);
}

.no-services-msg {
    grid-column: 1 / -1;
    text-align: center;
    padding: 40px;
    color: var(--color-maroon);
    font-style: italic;
    font-weight: 500;
}
</style>